import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onSetSelectedSeller, selectSellerState, setAction, onFetchSellers } from "../redux/slices/sellerSlice"
import { SellersAPI } from "../apis/SellersAPI"
import { seller } from "../types/slices/sellerType"

export const useSellerStore = () => {

    const dispatch = useDispatch()
    const { sellers, sellerSelected, status, action } = useSelector(selectSellerState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getSellers = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SellersAPI.getSellers({search:search})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getSellersByCompany = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SellersAPI.getSellersByCompany({search:search, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getSellersERP = async () => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SellersAPI.getSellersERP()
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            dispatch(onFetchSellers(detail))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createSeller = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SellersAPI.createSeller({...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editSeller = async (idseller: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SellersAPI.editSeller(idseller, {...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteSeller = async (idseller: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SellersAPI.deleteSeller(idseller)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedSeller = (seller: seller) => {
        try {
            dispatch(onSetSelectedSeller(seller))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionSeller = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        sellers,
        sellerSelected,
        status,
        action,
        //actions
        getSellers,
        getSellersERP,
        getSellersByCompany,
        createSeller,
        editSeller,
        deleteSeller,
        setSelectedSeller,
        setActionSeller,
    }
}